<div class="widget" [ngClass]="{'loader-shown': loading}" [class.initial]="timeLeftToStart > 0 && !loading">
  <div class="widget-loader widget-loader-peer-review">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="arc-loading"></div>
      <div class="loader-element image-loading"></div>
      <div class="loader-element small-loading"></div>
      <div class="loader-element button-loading"></div>
    </div>
  </div>
  <div class="widget-header">
    <span class="custom-icon">
      <span class="icon material-icons">how_to_reg</span>
    </span>
    <span class="title">{{ stageName }}</span>
  </div>
  <div class="widget-content">
    <div *ngIf="!stageId">Not connected to a stage</div>

    <div *ngIf="stageId && timeLeftToStart > 0" class="default-state">
      <img src="assets/images/widget/peer-review.png"/>
      <span class="inner-title">{{ roundTime(timeLeftToStart) }} {{ timeLeftString }}</span>
      <span class="inner-message">left until {{ stageName }} begins</span>
    </div>

    <div *ngIf="stageId && !isEliminated && !resultsReleased && timeLeftToStart <= 0" class="reviews">

      <div class="arc">
        <div [style]="calculatedArcStyle"></div>
      </div>

      <div class="text">
        <span>{{ completedReviews }}</span>
        <span>OUT OF {{ neededReviews }}</span>
      </div>

    </div>

    <div *ngIf="stageId && isEliminated && timeLeftToStart <= 0" class="custom-message">
      <span class="icon material-icons passed-deadline">cancel</span>
      <p>System Message</p>
      <small>We regret to inform you that you have been eliminated from the competition at this stage.</small>
    </div>

    <div *ngIf="stageId && resultsReleased && !isEliminated && timeLeftToStart <= 0" class="custom-message">
      <span class="icon material-icons submitted">check_circle</span>
      <p>Your results are ready!</p>
      <small>Visit the link to see the scores and feedback provided for your application.</small>
    </div>

    <button class="button button-primary" *ngIf="stageId && !isEliminated && timeLeftToStart <= 0" [routerLink]="buttonLink">         
      {{ buttonText }}
    </button>

  </div>
</div>